// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1mggO","loaderOuter":"PageOverlayLoader_loaderOuter__SKpP_"};